/* eslint-disable */
(function ($) {
    let $dealerSelect = $('#dealer-countries'), $modal = $('#modalDealer');
    $dealerSelect.on('change', function () {
        let $self = $(this), data = {
            action: 'dealer_posts',
            zirbus_nonce: dealer_posts_vars.zirbus_nonce,
            country_name: $self.find('option:selected').text(),
            country_id: $self.val(),
            current_lang: dealer_posts_vars.current_lang
        };

        $.ajax({
            url: dealer_posts_vars.zirbus_ajax_url,
            dataType: 'json',
            type: 'POST',
            data: data,
            success: function (data, textStatus, XMLHttpRequest) {
                if (textStatus === 'success' && data.posts && data.status === 'success') {
                    $modal.find('.modal-title').text($self.find('option:selected').text())
                    $modal.find('.modal-body').html(data.posts)
                } else {
                    $('<div class="alert alert-info mt-2" role="alert">' + dealer_posts_vars.zirbus_empty_mrsg + '</div>').insertAfter($self);
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                $modal.modal('hide')
                $('<div class="alert alert-danger mt-2" role="alert">' + dealer_posts_vars.zirbus_error_mrsg + '</div>').insertAfter($self);
            },
            complete: function (data, textStatus) {
                if (textStatus === 'success' && data.responseJSON.status === 'success') {
                    $modal.modal('toggle');
                }
            }
        });
        return false;
    });
})(jQuery);


// WEBPACK FOOTER //
// ./scripts/ajax-dealer-posts.js